import { useDispatch, useSelector } from "react-redux";
import { OnboardSelect } from "../../Onboard/OnboardComponents/Dropdown/Select";
import DatePickerHandle from "../../Onboard/OnboardComponents/KeyboardDatePicker";
import { useEffect, useRef, useState } from "react";
import { getOriginatingCountry } from "../../../actions/Onboard.action";
import { getTimeZoneData, getUPNValidation, updateAddUserStart } from "../../../actions/Administration/adminView.action";
import { getEmployeeMappingAccountsData, getEmployeeMappingRolesData, getEmployeeMappingSitesData, updateUsermembershipDataStart } from "../../../actions/employeeMapping.action";
import './EmployeeMapping.css';
import deleteIcon from '../../../assets/images/Delete_Icon.png';


export function UserMembershipModal(props) {
  const dispatch = useDispatch();
   const [file, setFile] = useState("");
   const [error, setError] = useState();
   const [datacard, setDatacard] = useState(false);
   const [validation, setValidation] = useState('');
   const [addUser, setAddUser] = useState({
  Name: '',
  UPN: '',
  Email: '',
  ValidUntil: null,
  Blocked: false,
  City: '',
  Country: '',
  TimeZone: '',
});

   
   
  let countryInfo = useSelector((state) => state.onboardReducer.originatingCountry);
  let timezoneData = useSelector((state) => state.adminViewReducer.timezoneData);
  let UPNValidation = useSelector((state) => state.adminViewReducer.UPNValidation);
  const UPNError = useSelector((state) => state.adminViewReducer.error);

  console.log('errorstatus',UPNError)

  useEffect(() => {
    dispatch(getOriginatingCountry());
    dispatch(getTimeZoneData());
  }, [dispatch])


  const HandleAddUser = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute('name');
    const fieldValue = event.target.value;
    if (fieldValue !== 'Select') {
      const newFormData = { ...addUser };
      newFormData[fieldName] = fieldValue;
      setAddUser(newFormData)
    }
    if (fieldName === 'UPN') {
      console.log('fieldValue',fieldValue)
      dispatch(getUPNValidation(fieldValue))
    }
  }
  const addValueToUser = (name, value) => {
    const newFormData = { ...addUser };
    if (name !== 'Select') {
      newFormData[name] = value;
      setAddUser(newFormData)
    }
  }

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [month, day, year].join('/');
  }

  const ValidUntilDateHandler = (date) => {
    setAddUser({ ...addUser, ValidUntil: (date === null || date === undefined) ? null : formatDate(date) });

  }

  const onChangeValue = (event) => {
    const fieldName = event.target.getAttribute('name');
    const fieldValue = event.target.value;
    if (fieldValue !== 'Select') {
      const newFormData = { ...addUser };
      newFormData[fieldName] = JSON.parse(fieldValue);
      setAddUser(newFormData)
    }
  }

   function handleUpload(event) {
        event.preventDefault();
        const file = event.target.files[0];
        if (file && file.size > 1000000) {
            setError('Please upload a file less than 1MB');
            setFile('');
            setDatacard(false);
        } else if (file) {
            setFile(file);
            setError('');
            setDatacard(true);
        }
    }

    function generateRandomId() {
        return 'file-' + Math.random().toString(36).substr(2, 9);
    }
        const hiddenFileInput = useRef(null);
    
console.log('UPNValidation.length',UPNValidation.length)

function deleteHandler() {
  setFile('');
  setDatacard(false);
}

const handleSubmission = () => {
  const formData = new FormData();

  formData.append('File', file);

  fetch(
    `${
      process.env.REACT_APP_BASE_URL
    }/api/users/${addUser.Email}/photo`,
    {
      method: 'POST',
      body: formData,
    }
  )
    .then((response) => response.json())
    .then((result) => {
      console.log('Success:', result);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};


// const dispobj = () =>{
 
//   let temparr = {
//     ID:"",
//     Name:addUser.Name,
//     UPN:addUser.UPN,
//     Email:addUser.Email,
//     ValidUntil:addUser.ValidUntil,
//     Blocked:addUser.Blocked === 'true' ? 1 : 0,
//     City:addUser.City,
//     Country:addUser.Country,
//     TimeZone:addUser.TimeZone,
//   }
//   console.log('dispOBJ',[temparr])
//   const temp_Arr = {
//     Name:addUser.Name,
//     UPN:addUser.UPN,
//     Email:addUser.Email
// }
// function ValidateEmail() 
// {
//  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(addUser.Email))
//   {
//     return (true)
//   }
//     return (false)
// }

// const isEmptyInput = Object.values(temp_Arr).some(x => (x === null || x === '' || x === undefined));
// if (isEmptyInput) {
//     setValidation('Please Ensure you filled all the inputs with  " * " mark ')
// }
// else if(UPNError){
//   setValidation('UPN already Exists, Please Enter the different UPN')
// }
// else if(!ValidateEmail()){
//   setValidation('Invalid Email, Please Enter the valid Email Address')
// }
// else{
//   dispatch(updateAddUserStart([temparr]));
//   setValidation('');
//   handleSubmission();
//   props.closeModel();
// }
// }

const dispobj = async () => {
  const temp_Arr = {
    Name: addUser.Name,
    UPN: addUser.UPN,
    Email: addUser.Email
  };

  const isEmptyInput = Object.values(temp_Arr).some(
    x => !x || x === ""
  );

  function ValidateEmail() {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(addUser.Email);
  }

  if (isEmptyInput) {
    setValidation('Please Ensure you filled all the inputs with "*" mark');
    return;
  }

  if (!ValidateEmail()) {
    setValidation('Invalid Email. Enter a valid Email Address');
    return;
  }

  // ------------------------------------------------
  // 🔥 FINAL SUBMIT USING ONLY POST API
  // ------------------------------------------------

  const newUserObj = {
    ID: "",
    Name: addUser.Name,
    UPN: addUser.UPN,
    Email: addUser.Email,
    ValidUntil: addUser.ValidUntil,
    Blocked: addUser.Blocked ? 1 : 0,
    City: addUser.City,
    Country: addUser.Country,
    TimeZone: addUser.TimeZone,
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/users/create`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newUserObj),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      if (result?.message?.includes("duplicate") || 
          result?.error?.includes("duplicate") ||
          JSON.stringify(result).includes("duplicate")
      ) {
        setValidation("UPN already Exists. Please enter a different UPN.");
        return; // ❌ Do NOT close modal
      }

      setValidation("Something went wrong. Please try again.");
      return;
    }

    // Success → Upload file (optional)
    if (file) {
      await handleSubmission();
    }

    setValidation("");

    // SUCCESS → now close modal
    props.closeModel();

  } catch (error) {
    console.error(error);
    setValidation("Server Error. Please try again later.");
  }
};


console.log('validation',validation)


  return <div>
       <div style={{ color: '#ED4F32',marginLeft:10 }}>{validation}</div>

    <main className='main_container_onebythree'>
      <div className='container_onebythree_width'>
        <label>Name *</label>

        <input type='text'
          name='Name'
          value={addUser?.Name}
          placeholder='Example: Balaban, Cosmin'
          onChange={(e) => HandleAddUser(e)}
        />
      </div>
      <div className='container_onebythree_width'>
        <label>UPN *</label>

        <input type='text'
          name='UPN'
          value={addUser?.UPN}
          placeholder='Example: cosmin.balaban@dxc.com'
          onChange={(e) => HandleAddUser(e)}
        />
      </div>
       <div className='container_onebythree_width'>
        <label>Email ID *</label>

        <input type='text'
          name='Email'
          value={addUser?.Email}
          placeholder='Example: cosmin.balaban@dxc.com'
          onChange={(e) => HandleAddUser(e)}
        />
      </div>
    </main>

    <main className='main_container_onebythree'>
     <div className='container_onebythree_width'>
        <DatePickerHandle className='container-three' label='Valid Until' id='label' width='200px'
          value={(addUser?.ValidUntil === undefined || addUser?.ValidUntil === null) ? null : addUser?.ValidUntil}
          onChange={(date) => ValidUntilDateHandler(date)}
        />
      </div>
      <div className='container_onebythree_width'>
        <label HtmlFor='country'>Country</label>
        <OnboardSelect data={countryInfo} name='Country' value='Country' id='Id' marginTop='10px'
          editValue={addUser?.Country} addValueToQueue={addValueToUser} />
      </div>
      <div className='container_onebythree_width'>
        <label>City</label>

        <input type='text'
          name='City'
          value={addUser?.City}
          placeholder='Example: Bucharest'
          onChange={(e) => HandleAddUser(e)}
        />
      </div>
    </main>

    <main className='main_container_onebythree'>
      <div className='container_onebythree_width'>
        <label HtmlFor='country'>Time Zone</label>
        <OnboardSelect data={timezoneData} name='TimeZone' value='Timezone' id='Id' marginTop='10px'
          editValue={addUser?.TimeZone} addValueToQueue={addValueToUser} />
      </div>
      <div className="radio_buttons" onChange={onChangeValue} style={{ marginTop: 0 }}>Blocked<br />
        <input type="radio" id="true" name="Blocked" value={true} required
          className="radio_input_user" checked={addUser?.Blocked === true} />
        <label for="valid">Yes</label>
        <input type="radio" id="false" name="Blocked" value={false}
          className="radio_input_user" checked={addUser?.Blocked === false} />
        <label for="Exemption">No</label>
      </div>
    </main>

    <main style={{ marginTop: '0px' }}>
      <div className='complete_preview'>Attach File</div>
      <div className='role_preview'>You can upload only PNG, JPEG and SVG files. Maximum upload file size is 1MB.</div>

      <section style={{ display: 'flex', gap: 20, marginTop: 20 }}>    <div id="upload-box">
        <form>
          <input type="file" id={generateRandomId()} ref={hiddenFileInput} name="myImage" accept="image/png, image/svg, image/jpeg" onChange={handleUpload} style={{ borderBottom: 0 }} />
        </form>
      </div>
        <div> {file.name && <img src={deleteIcon} alt='del' style={{ marginLeft: 20, cursor: 'pointer' }} onClick={deleteHandler}/>}</div></section>
      <div style={{ color: 'red' }}>{error}</div>
      {/* {datacard && <div className='card__upload'> <span>{file.name}</span>
                                        <span >{(file.size) / 1024} KB <img src={deleteIcon} alt='del' style={{ marginLeft: 20, cursor: 'pointer' }} onClick={deleteHandler} /></span>
                                    </div>} */}
    </main>


    <main style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
      <button type='submit' className='btn_adduser' onClick={()=>{dispobj()}}> ADD
            </button>
            <button className='btn_canceluser' onClick={()=>{props.closeModel()}}>CANCEL
            </button>
          </main>

   
  </div>;
}

export function AccountAssignmentModal(props) {
  const dispatch = useDispatch();
  const employeeMappingRoles = useSelector((state) => state.EmployeeMappingReducer.employeeMappingRoles);
  const employeeMappingAccounts = useSelector((state) => state.EmployeeMappingReducer.employeeMappingAccounts);
  const employeeMappingSites = useSelector((state) => state.EmployeeMappingReducer.employeeMappingSites);

  console.log('employeeMappingRoles', employeeMappingRoles, employeeMappingAccounts, employeeMappingSites)

  const[formData,setFormData] = useState();
  const[selectedDate,setSelectedDate] = useState({});



  useEffect(() => {
    dispatch(getEmployeeMappingRolesData());
    dispatch(getEmployeeMappingAccountsData());
    dispatch(getEmployeeMappingSitesData());
  }, [dispatch])

 const addValueToRoleAccount = (name, value) => {
        const newFormData = { ...formData };
        if (name !== 'Select') {
            newFormData[name] = value;
            setFormData(newFormData)
        }
    }

    function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [month, day, year].join('/');
  }

const FromDateHandler = (date) => {
  setSelectedDate({...selectedDate, From: (date === null || date === undefined) ? null : formatDate(date)});
  
}

const ToDateHandler = (date) => {
  setSelectedDate({...selectedDate, To: (date === null || date === undefined) ? null : formatDate(date)});
  
}

const submitHandler = () => {
  let dispobj = [
    {
      "Agent":props.agent,
      "CustomerID":formData.customer.id,
      "ServicedeskID":formData.servicedesk.id,
      "RoleID":formData.role.id
    }
  ]
  dispatch(updateUsermembershipDataStart(dispobj));
  props.closeModel();
}

    console.log('formData',formData,selectedDate)
  return <div>
    <section >
      <div>
        <div className='user_model_title Margin_b20'>
              Add Role and Account
            </div>
        <div>
          <main style={{ display: 'flex', gap: 20 }} className="Margin_b20">
            <div className='container_onebythree'>
              <label HtmlFor='country'>Role *</label>
              <OnboardSelect data={employeeMappingRoles} name='role' value='role' id='id' marginTop='10px'
                editValue='' addValueToQueue={addValueToRoleAccount} passFullObject={true}/>
            </div>
            <div className='container_onebythree'>
              <label HtmlFor='country'>Site *</label>
              <OnboardSelect data={employeeMappingSites} name='servicedesk' value='servicedesk' id='id' marginTop='10px'
                editValue='' addValueToQueue={addValueToRoleAccount} passFullObject={true}/>
            </div>
            <div className='container_onebythree'>
              <label HtmlFor='country'>Account</label>
              <OnboardSelect data={employeeMappingAccounts} name='customer' value='customer' id='id' marginTop='10px'
                editValue='' addValueToQueue={addValueToRoleAccount} passFullObject={true}/>
            </div>
          </main>
          <main style={{ display: 'flex', gap: 20 }}>
            <DatePickerHandle  label='From' id='label'  value={(selectedDate?.From === undefined || selectedDate?.From === null) ? null : selectedDate?.From}
            onChange={(date) => FromDateHandler(date)}/>
            <DatePickerHandle  label='To' id='label' value={(selectedDate?.To === undefined || selectedDate?.To === null) ? null : selectedDate?.To}
            onChange={(date) => ToDateHandler(date)}/>
          </main>

          <main style={{ display: 'flex', gap: '30px',justifyContent:'center'}}>
            <button type='submit' className='btn_adduser' onClick={()=>{submitHandler()}}> ADD
            </button>
            <button className='btn_canceluser' onClick={()=>{props.closeModel()}}>CANCEL
            </button>
          </main>
          <div>
          </div>
        </div>
      </div>
    </section>
  </div>;
}
